export default "__VITE_ASSET__BJBnpgW7__"